import { CustomColumn } from "../../../components/Tables/record/RecordTable";
import { DocumentSequenceAdminDTO } from "../../../types/settings/correlatives/DocumentSequenceAdminDTO";

export const correlativesAdminColumns: CustomColumn<DocumentSequenceAdminDTO>[] = [
  {
    Header: 'Sucursal',
    accessor: 'branchName',
  },
  {
    Header: 'Tipo Documento',
    accessor: 'documentTypeName',
  },
  {
    Header: 'Prefijo',
    accessor: 'prefix',
  },
  {
    Header: 'Correlativo Actual',
    accessor: 'currentNumber',
    customCell: ({ value }) => (
      <span className="font-semibold">
        {value}
      </span>
    ),
  },
  {
    Header: 'Último Reset',
    accessor: 'lastResetYear',
  },
];
